'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce = require('./debounce');

Object.defineProperty(exports, 'debounce', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_debounce).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/function-tree/lib/factories/index.js
// module id = 263
// module chunks = 0